<template>
  <div id="app" class="indexPage">
    <RenderSettings
      :parentid="parentid"
      :endPoint="apiendpoint"
      :culture="language"
    >
      <template v-slot:settings="{ settings }">
        <div class="filterModalWrap">
          <form
            class="indexFiltersModal"
            id="indexFilterPanelControl"
            role="region"
            aria-labelledby="indexFilterPanelID"
            aria-hidden="true"
            @submit.prevent=""
            ref="panelContent"
            v-click-outside="onClickOutsideFilterPanel"
            @keydown.esc="panelEsc"
            :class="!settings.enableKeywordSearch ? 'noKeywordSearch' : ''"
            v-if="
              settings.taxonomy?.tagGroups.length > 0 ||
                settings.enableKeywordSearch
            "
          >
            <button
              class="filterModalClose"
              :aria-label="$t('Web.Aria.CloseFilters')"
              @click="filterSidebarCloseClick"
              ref="filterModalClose"
            >
              {{ $t("Web.Containers.Close") }}
              <svg
                width="12"
                height="13"
                viewBox="0 0 12 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 11.5L11 1.5M1 1.5L11 11.5"
                  stroke="#2D3232"
                  stroke-width="1.67"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <div
              class="filterTitleWrapper"
              v-if="settings.enableKeywordSearch"
              :class="settings.taxonomy.tagGroups.length > 0 ? '' : 'noFilters'"
            >
              <div class="filterTitle">
         
                  <svg
                    role="img"
                    aria-hidden="true"
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="2" width="2" height="17" fill="#2D3232" />
                    <rect x="9" width="2" height="17" fill="#2D3232" />
                    <rect x="16" width="2" height="17" fill="#2D3232" />
                    <rect
                      x="1"
                      y="3"
                      width="4"
                      height="4"
                      fill="#E0D4C8"
                      stroke="#2D3232"
                      stroke-width="2"
                    />
                    <rect
                      x="8"
                      y="12"
                      width="4"
                      height="4"
                      fill="#E0D4C8"
                      stroke="#2D3232"
                      stroke-width="2"
                    />
                    <rect
                      x="15"
                      y="1"
                      width="4"
                      height="4"
                      fill="#E0D4C8"
                      stroke="#2D3232"
                      stroke-width="2"
                    />
                  </svg>
                  {{ $t("Web.Containers.Filter") }}
              </div>

              <div class="searchInput" :class="keywordError && 'searchError'">
                <label for="searchFilterInput">{{
                  $t("Web.Containers.SearchLabel")
                }}</label>
                <div class="searchInputFilterWrapper">
                  <input
                    id="searchFilterInput"
                    @keydown.enter.prevent="applyFilters"
                    type="search"
                    :placeholder="$t('Web.Containers.SearchPlaceholder')"
                    v-model="keyword"
                    autocomplete="off"
                  />
                  <button
                    class="clearButton"
                    v-if="keyword.length > 0"
                    @click="clearKeyword"
                    :aria-label="$t('Web.Containers.ClearKeyword')"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      preserveAspectRatio="xMinYMid"
                      aria-hidden="true"
                      role="img"
                      fill="#1A1347"
                    >
                      <g>
                        <path
                          d="M315.25 20.25V31H326v1.5h-10.75v10.75h-1.5V32.5H303V31h10.75V20.25h1.5z"
                          transform="translate(-305 -79) translate(0 56) rotate(45 314.5 31.75)"
                        />
                      </g>
                    </svg>
                  </button>
                  <button
                    class="searchButton"
                    :aria-label="$t('Web.Containers.SearchButtonAria')"
                    @click="applyFilters"
                  >
                    <svg
                      role="img"
                      ariah-hidden="true"
                      width="17"
                      height="17"
                      viewBox="0 0 17 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M16 16L11 11M12.6667 6.83333C12.6667 10.055 10.055 12.6667 6.83333 12.6667C3.61167 12.6667 1 10.055 1 6.83333C1 3.61167 3.61167 1 6.83333 1C10.055 1 12.6667 3.61167 12.6667 6.83333Z"
                        stroke="#2D3232"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
                <span class="searchInputErrorMessage" v-if="keywordError">
                  {{ $t("Web.Containers.SearchErrorKeywordLength") }}
                </span>
              </div>
            </div>

            <!-- filter items -->
            <div
              class="indexFiltersInner"
              v-if="settings.taxonomy.tagGroups.length > 0"
              tabindex="1"
              @keydown="applyFilters"
            >
              
              <Filters
                :tagGroups="settings.taxonomy?.tagGroups"
                @selectedTagsUpdated="updateCurrentSelectedTags($event)"
                @tagUpdated="updateTags($event)"
                :selectedTags="currentSelectedTags"
                class="selectWrapper"
              ></Filters>

              <!-- results in the filter panel -->
              <div class="panelResults">
                <div
                  class="filterItemsResultsWrapper"
                  v-if="currentSelectedTags.length > 0"
                >
                  <p>Applied filters:</p>
                  <ChosenTags
                    :tags="currentSelectedTags"
                    v-on:clearTag="
                      (tag) => {
                        currentSelectedTags.splice(
                          currentSelectedTags.indexOf(tag),
                          1
                        );
                      }
                    "
                  ></ChosenTags>
                  <button
                    class="clearAll"
                    v-if="tags.length > 0"
                    v-on:click="
                      () => {
                        currentSelectedTags = [];
                      }
                    "
                  >
                    {{ $t("Web.Containers.ClearAll") }}
                  </button>
                </div>

                <div class="applyButton setting-closeButton">
                  <button @click="applyFilters" @keydown.tab="lastFocusTab">
                    {{ $t("Web.Containers.Apply") }}
                    <svg
                      role="img"
                      aria-hidden="true"
                      width="7"
                      height="13"
                      viewBox="0 0 7 13"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1.5L6 6.5L1 11.5"
                        stroke="white"
                        stroke-width="1.67"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </form>
          <div class="overlay"></div>
        </div>

        <div class="indexFilter">
          <div class="container">
            <div class="inner">
              <h1>{{ title }}</h1>
              
              <div
                class="filters"
                v-if="
                  settings?.sortOrder?.length > 0 ||
                    settings.enableKeywordSearch ||
                    settings.taxonomy?.tagGroups.length > 0
                "
              >
                <SortOrderDropDown
                  :dropdownId="'indexSortBy'"
                  :options="settings?.sortOrder"
                  :label="'Sort by'"
                  @sortOrderChange="updateSortData"
                  v-if="settings?.sortOrder.length > 1"
                />
                <button
                  aria-expanded="false"
                  aria-controls="indexFilterPanelControl"
                  id="indexFilterPanelID"
                  :aria-label="$t('Web.Aria.OpenFilters')"
                  ref="panelButton"
                  @click="filterSidebarClick"
                  v-if="
                    settings.enableKeywordSearch ||
                      settings.taxonomy?.tagGroups.length > 0
                  "
                >
                  <svg
                    role="img"
                    aria-hidden="true"
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="2" width="2" height="17" fill="#2D3232" />
                    <rect x="9" width="2" height="17" fill="#2D3232" />
                    <rect x="16" width="2" height="17" fill="#2D3232" />
                    <rect
                      x="1"
                      y="3"
                      width="4"
                      height="4"
                      fill="#E0D4C8"
                      stroke="#2D3232"
                      stroke-width="2"
                    />
                    <rect
                      x="8"
                      y="12"
                      width="4"
                      height="4"
                      fill="#E0D4C8"
                      stroke="#2D3232"
                      stroke-width="2"
                    />
                    <rect
                      x="15"
                      y="1"
                      width="4"
                      height="4"
                      fill="#E0D4C8"
                      stroke="#2D3232"
                      stroke-width="2"
                    />
                  </svg>
                  {{ getSearchButtonText(settings) }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="appliedResults"
          v-if="tags.length > 0"
          v-on:clearTag="clearTag"
        >
          <div class="container">
            <div class="inner">
              <p v-if="tags.length > 0" v-on:clearTag="clearTag">
                {{ $t("Web.Containers.AppliedFilters") }}:
              </p>

              <div class="filterItemsWrapper">
                <ChosenTags :tags="tags" v-on:clearTag="clearTag"></ChosenTags>
                <button
                  class="clearAll"
                  v-if="tags.length > 0"
                  v-on:click="clearAllTags"
                >
                  {{ $t("Web.Containers.ClearAll") }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="generalIndexResults background-beige">
          <RenderResources
            :parentid="parentid"
            :endPoint="apiendpoint"
            :tags="selectedTags"
            :images="images"
            :additionalFields="additionalFields"
            :additionalFieldsMultiLingual="additionalFieldsMultiLingual"
            :page="currentActivePage"
            :keyword="keywordInput"
            :pagesize="pagesize"
            :sortOrder="sortOrder"
            :sortType="sortType"
            :sortIsDesc="sortIsDesc"
            :language="language"
            :personalisationGroupIds="personalisationGroupIds"
            @change="resourcesChanged($event, pagesize)"
          >
            <template v-slot:search="{ result, loading, error }">
              <div class="container">
                <div
                  class="noResults"
                  v-if="
                    !loading &&
                      !error &&
                      (result === undefined ||
                        result.results === undefined ||
                        result.results.length === 0)
                  "
                >
                  <svg
                    role="img"
                    aria-hidden="true"
                    width="91"
                    height="91"
                    viewBox="0 0 91 91"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M65.9175 65.9172L88.9999 88.9997"
                      stroke="#2D3232"
                      stroke-width="5"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M39.8572 76.7144C60.2129 76.7144 76.7144 60.2129 76.7144 39.8572C76.7144 19.5015 60.2129 3 39.8572 3C19.5015 3 3 19.5015 3 39.8572C3 60.2129 19.5015 76.7144 39.8572 76.7144Z"
                      stroke="#2D3232"
                      stroke-width="5"
                      stroke-miterlimit="10"
                    />
                    <path
                      d="M56.7415 26.5205H49.9971V33.265H56.7415V26.5205Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M49.9334 20.0166H43.189V26.7611H49.9334V20.0166Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M49.9334 33.187H43.189V39.9315H49.9334V33.187Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M36.5164 19.8542H29.772V26.5987H36.5164V19.8542Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M29.7718 26.5986H23.0273V33.3431H29.7718V26.5986Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M43.1922 39.8533H36.4478V46.5977H43.1922V39.8533Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M43.1922 59.6899H36.4478V66.4344H43.1922V59.6899Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M43.1922 46.5198H36.4478V53.2642H43.1922V46.5198Z"
                      fill="#2D3232"
                    />
                    <path
                      d="M43.1922 13.3501H36.4478V20.0946H43.1922V13.3501Z"
                      fill="#2D3232"
                    />
                  </svg>

                  <h3>
                    {{ $t("Web.Containers.NoResultsTitle") }}
                  </h3>
                  <p>
                    {{ $t("Web.Containers.NoResultsText") }}
                  </p>
                </div>
                <div class="error" v-if="error">
                  {{ $t("Web.Containers.LoadingResourceError") }}
                </div>

                <div
                  class="itemContainer"
                  v-if="resultType === 'ResultArticles'"
                >
                  <div
                    class="itemInner"
                    v-bind:class="resultType"
                    v-if="
                      !error &&
                        result.results !== undefined &&
                        result.results.length > 0
                    "
                  >
                    <ResultItemsContainer
                      :results="result"
                      :ctas="settings.ctas"
                      :ctaFrequency="settings.ctaFrequency"
                      :resultType="resultType"
                      :language="language"
                      :defaultSiteImageUrl="settings.defaultSiteImageUrl"
                    />
                  </div>
                </div>

                <div class="splide" v-else>
                  <div
                    class="splide__track"
                    v-bind:class="resultType"
                    v-if="
                      !error &&
                        result.results !== undefined &&
                        result.results.length > 0
                    "
                  >
                    <ResultItemsContainer
                      :results="result"
                      :ctas="settings.ctas"
                      :ctaFrequency="settings.ctaFrequency"
                      :resultType="resultType"
                      :language="language"
                      :defaultSiteImageUrl="settings.defaultSiteImageUrl"
                    />
                  </div>
                </div>

                <div class="loading" v-if="loading && !error">
                  <p>{{ $t("Web.Containers.LoadingResults") }}</p>
                </div>
              </div>

              <div
                v-if="currentActivePage < totalPages"
                class="resultsAndButton"
                v-bind:class="resultType"
              >
                <div class="container">
                  <div class="wrap">
                    <ResultsIndicator
                      v-if="result.totalResults > 0"
                      :first="firstPage(currentActivePage, pagesize)"
                      :term="keywordInput"
                      :last="lastPage(result.totalResults, pagesize)"
                      :total="result.totalResults"
                      :indexTitle="title"
                    ></ResultsIndicator>

                    <button
                      @click="
                        (evt) => {
                          evt.preventDefault();
                          paginationClick(currentActivePage + 1);
                        }
                      "
                    >
                      {{ $t("Web.Containers.ShowMore") }}
                      <svg
                        role="img"
                        aria-hidden="true"
                        width="12"
                        height="8"
                        viewBox="0 0 12 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 1.5L6 6.5L1 1.5"
                          stroke="white"
                          stroke-width="1.67"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </RenderResources>
        </div>
      </template>
    </RenderSettings>
  </div>
</template>

<script lang="ts">
import ChosenTags from "../components/ChosenTags.vue";
import Filters from "../components/Filters.vue";
import PreSelectedFilters from "../components/PreSelectedFilters.vue";
import SortOrderDropDown from "../components/SortOrderDropDown.vue";
import ResultsIndicator from "../components/ResultsIndicator.vue";
import ResultsReturned from "../components/ResultsReturned.vue";
import ResultItemsContainer from "../components/ResultItemsContainer.vue";
import RenderResources from "../components/renderless/RenderResources.vue";
import RenderSettings from "../components/renderless/RenderSettings.vue";
import { defineComponent, Ref, ref, watch, onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";
import {
  paginationClick,
  lastPage,
  firstPage,
  totalPages,
  currentActivePage
} from "../common/pagination";
import {
  resourcesChanged,
  clearKeyword,
  updateKeyword,
  keywordInput,
  keyword
} from "../common/searching";
import {
  updateTags,
  clearTag,
  clearAllTags,
  tags,
  selectedTags
} from "../common/tags";
import { QueryString } from "../models/queryString";
import { parseQueryString } from "../common/urlHelpers";
import { SelectedCtaModel } from "../clients/search/src/models";
import { SortOrderOption } from "../models/sortOrderOptions";
import vClickOutside from "click-outside-vue3";
import "../extensions/string.extensions";

export default defineComponent({
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    Filters,
    PreSelectedFilters,
    SortOrderDropDown,
    ResultsIndicator,
    ResultsReturned,
    RenderResources,
    ChosenTags,
    ResultItemsContainer,
    RenderSettings
  },
  props: {
    showkeywords: {
      type: Boolean,
      required: true,
      default: true
    },
    filtergroupids: {
      type: String,
      required: true,
      default: ""
    },
    filteryear: {
      type: Boolean,
      required: true,
      default: true
    },
    parentid: {
      type: Number,
      required: true,
      default: -1
    },
    pagesize: {
      type: Number,
      required: true,
      default: 20
    },
    title: {
      type: String,
      required: true,
      default: ""
    },
    resultType: {
      type: String,
      required: true,
      default: ""
    },
    baseUri: {
      type: String,
      required: true,
      default: ""
    },
    language: {
      type: String,
      required: false,
      default: ""
    },
    personalisationGroupIds: {
      type: String,
      required: false,
      default: ""
    }
  },

  setup(props) {
    const { t } = useI18n();
    const apiendpoint = `${props.baseUri}`;
    let sortOrder = ref("score");
    let sortType = ref("Score");
    const panelContent: Ref<HTMLElement | null> = ref(null);
    const filterModalClose: Ref<HTMLElement | null> = ref(null);
    const panelButton: Ref<HTMLElement | null> = ref(null);
    let sortIsDesc = ref(false);
    const images = ["clientLogo", "previewImage"];
    const additionalFields: string[] = [];
    const additionalFieldsMultiLingual: string[] = [];
    const language = props.language;
    const personalisationGroupIds = props.personalisationGroupIds;
    const keywordError = ref(false);
    const preselectedFilterItem: Ref<SelectedCtaModel | undefined> = ref(
      undefined
    );
    const currentSelectedTags: Ref<{
      categoryId: string;
      count?: number;
      id: string;
      title: string;
    }[]> = ref([]);

    if (
      props.resultType === "ResultNews" ||
      props.resultType === "ResultEvents"
    ) {
      additionalFields.push("datestamp");
      additionalFields.push("displayDate");
      if (props.resultType === "ResultNews") {
        additionalFieldsMultiLingual.push("previewTagHeader");
      }
      if (props.resultType === "ResultEvents") {
        additionalFields.push("eventLocation");
      }
    }
    if (props.resultType === "ResultArticles") {
      additionalFields.push("previewTitle");
      additionalFields.push("previewTag");
      additionalFields.push("authorName");
      additionalFields.push("authorImage");
      additionalFields.push("displayDate");
      additionalFields.push("readTime");
      sortOrder = ref("date");
      sortType = ref("Long");
      sortIsDesc = ref(true);
    }

    if (props.resultType === "ResultClients") {
      additionalFields.push("previewTitle");
      additionalFields.push("previewTag");
    }

    onBeforeMount(() => {
      const qsParams: QueryString = parseQueryString();
      for (const paramKey in qsParams) {
        if (paramKey === "keyword") {
          keyword.value = qsParams[paramKey].toString();
          updateKeyword();
        }
      }
    });

    const updateSortData = (newVal: SortOrderOption) => {
      sortOrder.value = newVal.key;
      sortType.value = newVal.type;
      sortIsDesc.value = newVal.isDescending;
    };

    const keywordLengthOK = () =>
      keyword && (keyword.value.length === 0 || keyword.value.length > 2);

    const trySearch = () => {
      const keywordOK = keywordLengthOK();
      keywordError.value = !keywordOK;
      if (keywordOK) {
        updateKeyword();
      }
    };

    const onClickOutsideFilterPanel = (event) => {
      if (panelButton?.value) {
        panelButton.value.classList.remove("panelActive");
        panelButton.value.setAttribute("aria-expanded", "false");
      }

      if (panelContent?.value) {
        panelContent.value.setAttribute("aria-hidden", "true");
        panelContent.value.setAttribute("aria-expanded", "false");
        panelContent.value.classList.remove("panelActive");
      }

      document.documentElement.classList.remove("generalIndexFilterActive");
    };

    const filterSidebarClick = (event) => {
      event.stopPropagation();
      currentSelectedTags.value = tags.value;
      const panelButton = event.target;

      panelButton.classList.add("panelActive");
      panelButton.setAttribute("aria-expanded", "true");

      if (panelContent?.value) {
        panelContent.value.setAttribute("aria-hidden", "false");
        panelContent.value.setAttribute("aria-expanded", "true");
        panelContent.value.classList.add("panelActive");

        window.setTimeout(function() {
          filterModalClose.value.focus();
        }, 100);
      }
    };

    const filterSidebarCloseClick = (event) => {
      currentSelectedTags.value = tags.value;
      const panelButton = event.target;

      if (panelButton?.value) {
        panelButton.classList.remove("panelActive");
        panelButton.setAttribute("aria-expanded", "false");

        window.setTimeout(function() {
          panelButton.value.focus();
        }, 100);
      }

      if (panelContent?.value) {
        panelContent.value.setAttribute("aria-hidden", "true");
        panelContent.value.setAttribute("aria-expanded", "false");
        panelContent.value.classList.remove("panelActive");
      }

      document.documentElement.classList.remove("generalIndexFilterActive");
    };

    const clickFilters = (
      tagId: number,
      preselctedFilterList: SelectedCtaModel[]
    ) => {
      preselectedFilterItem.value = preselctedFilterList.find(
        (psf) => psf.tagId === tagId
      );
      clearAllTags();
      updateTags([
        {
          categoryId: preselectedFilterItem.value.categoryId.toString(),
          count: undefined,
          id: preselectedFilterItem.value.tagId.toString(),
          title: preselectedFilterItem.value.tagName
        }
      ]);
    };

    const updateCurrentSelectedTags = (
      updatedTagList: {
        categoryId: string;
        count?: number;
        id: string;
        title: string;
      }[]
    ) => {
      currentSelectedTags.value = updatedTagList;
    };

    const applyFilters = ($event) => {
      trySearch();
      if (keywordError.value) {
        $event.stopImmediatePropagation();
        $event.preventDefault();
        return;
      }
      if (panelButton?.value) {
        panelButton.value.classList.remove("panelActive");
        panelButton.value.setAttribute("aria-expanded", "false");

        window.setTimeout(function() {
          panelButton.value.focus();
        }, 100);
      }

      if (panelContent?.value) {
        panelContent.value.setAttribute("aria-hidden", "true");
        panelContent.value.setAttribute("aria-expanded", "false");
        panelContent.value.classList.remove("panelActive");
      }

      document.documentElement.classList.remove("generalIndexFilterActive");
      updateTags(currentSelectedTags.value);
    };

    const lastFocusTab = () => {
      if (panelButton?.value) {
        panelButton.value.classList.remove("panelActive");
        panelButton.value.setAttribute("aria-expanded", "false");

        window.setTimeout(function() {
          panelButton.value.focus();
        }, 100);
      }

      if (panelContent?.value) {
        panelContent.value.setAttribute("aria-hidden", "true");
        panelContent.value.setAttribute("aria-expanded", "false");
        panelContent.value.classList.remove("panelActive");
      }

      document.documentElement.classList.remove("generalIndexFilterActive");
    };

    const panelEsc = () => {
      if (panelButton?.value) {
        panelButton.value.classList.remove("panelActive");
        panelButton.value.setAttribute("aria-expanded", "false");

        window.setTimeout(function() {
          panelButton.value.focus();
        }, 100);
      }

      if (panelContent?.value) {
        panelContent.value.setAttribute("aria-hidden", "true");
        panelContent.value.setAttribute("aria-expanded", "false");
        panelContent.value.classList.remove("panelActive");
      }

      document.documentElement.classList.remove("generalIndexFilterActive");
    };

    const getSearchButtonText = (settings) => {
      const hasFilters = settings.taxonomy?.tagGroups.length > 0;
      const searchActive = settings.enableKeywordSearch;
      if (searchActive && hasFilters)  return t("Web.Containers.SearchAndFilter");
      if (searchActive && !hasFilters) return t("Web.Containers.Search");
      if (!searchActive && hasFilters) return t("Web.Containers.Filter");

      return "";
    };

    watch(
      () => keyword.value,
      (newVal) => {
        if (newVal.length === 0 || newVal.length > 2) {
          keywordError.value = false;
        }
      }
    );

    return {
      resourcesChanged,
      clearKeyword,
      updateKeyword,
      updateTags,
      paginationClick,
      lastPage,
      clearTag,
      clearAllTags,
      firstPage,
      updateSortData,
      keywordLengthOK,
      trySearch,
      clickFilters,
      filterSidebarClick,
      filterSidebarCloseClick,
      onClickOutsideFilterPanel,
      updateCurrentSelectedTags,
      applyFilters,
      currentSelectedTags,
      apiendpoint,
      tags,
      totalPages,
      selectedTags,
      currentActivePage,
      keywordInput,
      keyword,
      keywordError,
      images,
      additionalFields,
      additionalFieldsMultiLingual,
      sortOrder,
      sortType,
      panelContent,
      filterModalClose,
      panelButton,
      sortIsDesc,
      language,
      preselectedFilterItem,
      personalisationGroupIds,
      lastFocusTab,
      panelEsc,
      getSearchButtonText
    };
  }
});
</script>
